enum ServiceType {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY',
    OTHER = 'OTHER',
}

import { Service } from './addressBook.const';

export interface GroupedServices {
    pickup: Service[];
    delivery: Service[];
    other: Service[];
}

export const filterServicesByType = (services: Service[]): GroupedServices => {
    const groupedServices: GroupedServices = {
        pickup: [],
        delivery: [],
        other: [],
    };

    services.forEach((service) => {
        switch (service.type.toUpperCase()) {
            case ServiceType.PICKUP:
                groupedServices.pickup.push(service);
                break;
            case ServiceType.DELIVERY:
                groupedServices.delivery.push(service);
                break;
            default:
                groupedServices.other.push(service);
                break;
        }
    });

    return groupedServices;
};
